module.exports = __webpack_public_path__ + "static/media/cross.c907543c.svg";